export class AppConstants {
    public static get currencyIndicator(): string { return 'symbol-narrow'; }
    public static get digitsInfo(): string { return '1.2-3'; }
    public static get INSTRUCTOR_INTRO_EMAIL(): string {return 'instructor-introduction'; }
    public static get INSTRUCTOR_MAKRETING_EMAIL(): string {return 'instructor-marketing-email'; } 
    public static get INSTRUCTOR_SESSION_REQUIREMENTS_EMAIL(): string { return 'instructor-session-requirements-email'}
}